import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const modalStyles = {
    modal: {
        overflow: 'hidden',
        padding: 0,
        width: 300,
        height: 300,
    },
}

export const ModalContent = styled.div`
    width: 100%;
    height: 100%;
    ${FlexCentered}
    & > * {
        text-align: center;
    }
`
